import { render, staticRenderFns } from "./PopDocRead2.vue?vue&type=template&id=ede6e6be&scoped=true"
import script from "./PopDocRead2.vue?vue&type=script&lang=js"
export * from "./PopDocRead2.vue?vue&type=script&lang=js"
import style0 from "./PopDocRead2.vue?vue&type=style&index=0&id=ede6e6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede6e6be",
  null
  
)

export default component.exports